/* Auto-Created File, Do not edit directly. */
export const apiURI="https://test.playin.com.tr";
